import React from 'react';
import { Card, CardContent, CardMedia, Typography, Box } from '@mui/material';
import { Title } from '../types';

interface TitleCardProps {
    title: Title;
    showVotes?: boolean;
}

export const TitleCard: React.FC<TitleCardProps> = ({ title, showVotes = false }) => {
    return (
        <Card sx={{ maxWidth: 345, m: 1 }}>
            <CardMedia
                component="img"
                height="140"
                image={title.poster_url}
                alt={title.title_name}
            />
            <CardContent>
                <Typography gutterBottom variant="h6" component="div">
                    {title.title_name} ({title.release_year})
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {title.overview}
                </Typography>
                {showVotes && (
                    <Box sx={{ mt: 1 }}>
                        <Typography variant="body2" color="primary">
                            Requests: {title.vote_count}
                        </Typography>
                    </Box>
                )}
            </CardContent>
        </Card>
    );
};